import { render } from "./MasterTable.vue?vue&type=template&id=07f052e6"
import script from "./MasterTable.vue?vue&type=script&lang=ts"
export * from "./MasterTable.vue?vue&type=script&lang=ts"

const cssModules = script.__cssModules = {}
import style0 from "./MasterTable.vue?vue&type=style&index=0&id=07f052e6&lang=scss&module=true"
cssModules["$style"] = style0
script.render = render

export default script
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QBtnDropdown from 'quasar/src/components/btn-dropdown/QBtnDropdown.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QTable,QBtn,QInput,QIcon,QTd,QBadge,QTooltip,QList,QItem,QItemSection,QMenu,QBtnDropdown,QItemLabel});qInstall(script, 'directives', {ClosePopup});
